<template>
  <section>
    <div class="tip" style="margin: 25px 0 0 20px">* 合同内容</div>
    <ul class="project-info-list" v-if="project">
      <li class="block">
        <label>合同名称：</label>
        <div class="info-item">{{ form.name }}</div>
      </li>
      <li>
        <label>合同编号：</label>
        <div class="info-item">{{ form.number }}</div>
      </li>
      <!-- <li class="block">
        <label>所属项目：</label>
        <div class="info-item">{{ project.projectNames }}</div>
      </li> -->
      <li>
        <label>合同种类：</label>
        <!-- TODO 类型需要判断 -->
        <!-- 旧：1   新：2 -->
        <div v-if="form.flow.edition == '1'" class="info-item">
          {{ trpeArrOld[form.type] }}
        </div>
        <div v-else-if="form.ctype == 1">
          <div class="info-item">{{ typeArrJT[form.type] }}</div>
        </div>
        <div v-else>
          <div class="info-item">{{ typeArrZGS[form.type] }}</div>
        </div>
      </li>
      <li>
        <label>合同对方：</label>
        <div class="info-item">{{ form.customer }}</div>
      </li>
      <li>
        <label>合同价款(元)：</label>
        <div class="info-item">{{ form.price == "" ? "/" : form.price }}</div>
      </li>
    </ul>
    <ul class="project-info-list" v-if="form.ctype != 0">
      <li>
        <label>是否大客户：</label>
        <div class="info-item">{{ form.isBigCustomer == 1 ? "是" : "否" }}</div>
      </li>
      <li>
        <label>是否重大合同：</label>
        <div class="info-item">{{ form.isBigContract == 1 ? "是" : "否" }}</div>
      </li>
      <li v-if="form.ctype == 2">
        <label>是否'一户一表'工程：</label>
        <div class="info-item">{{ form.isYhyb == 1 ? "是" : "否" }}</div>
      </li>
    </ul>
    <ul class="project-info-list">
      <li class="block intro-box">
        <label>合同概要：</label>
        <div class="info-item">{{ form.outline }}</div>
      </li>
      <li class="block intro-box" v-if="form.ctype != 0">
        <label>合同款项结算内容：</label>
        <div class="info-item">{{ form.content }}</div>
      </li>
      <li class="block intro-box">
        <label>备注：</label>
        <div class="info-item">{{ form.remark }}</div>
      </li>
    </ul>
  </section>
</template>
<script>
export default {
  props: ["form", "userData", "project"],
  data() {
    return {
      // typeArr: ['工程施工合同', '物资采购合同', '服务类合同', '借款合同', '其他合同', '担保合同', '低值易耗品'],

      trpeArrOld: [
        "工程施工合同",
        "物资采购合同",
        "服务类合同",
        "借款合同",
        "其他合同",
        "担保合同",
        "低值易耗品",
      ],

      typeArrJT: [
        "采购类框架合同",
        "客户服务合同",
        "融资、担保合同",
        "其他合同",
      ],
      typeArrZGS: [
        "工程施工合同",
        "工程服务合同",
        "物资采购合同",
        "服务采购合同",
        "其他合同",
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/page/user/projectinfo/createContractApproval.vue